module.exports = __webpack_public_path__ + "static/media/jonathanSLux.fd6bdbdb.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/jonathanSLux.jpg
// module id = 1680
// module chunks = 1